import { ResponsiveBlockSwitcher } from "@/shared/Components";
import { LayoutDesktop } from "./desktop";
import { LayoutMobile } from "./mobile";

export const Layout = () => {
  return <ResponsiveBlockSwitcher desktop={<LayoutDesktop />} mobile={<LayoutMobile />} />;
};
